import Vue from 'vue'
import i18n from '../../plugins/i18n.js' 

const state = {
};

const getters = {
};

const mutations = {
}

const actions = {
    alert: ({ commit }, msg) => {
        let result = "";
        if (msg.errors) {
          
          Object.keys(msg.errors).forEach((errorKey) => {
            let ruleAttribute = {attribute: i18n.t("form.attributes." + errorKey)};
            if(msg.rules){

              Object.values(msg.rules[errorKey]).forEach((rule, ruleKey) => {
                if(rule.length > 0){
                  let ruleSplit = rule.split(':');
                  if(ruleSplit[1] && ruleSplit[1].length > 0){
                    ruleAttribute[ruleSplit[0]] = ruleSplit[1];
                  }
                }
              })

            }
            result = result + '</p>' + i18n.t(msg.errors[errorKey][0], ruleAttribute);
          })
        }
    
        Vue.notify({
          group: msg.group || 'default',
          title: i18n.t(msg.title),
          text: result,
          type: msg.type
        })
    },
    message: ({ commit }, msg) => {
        Vue.notify({
            group: msg.group || 'default',
            title: i18n.t(msg.title),
            text: i18n.t(msg.msg),
            type: msg.type
        })
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}